import styled, { css } from 'styled-components';
import Checkbox from '@/trio-ui/Checkbox';
import InputText from '@/trio-ui/InputText';

export const CustomInputText = styled(InputText)`
  width: 100%;
`;

const rowStyles = css`
  display: flex;
  align-items: center;
`;

export const CustomCheckbox = styled(Checkbox)`
  margin-right: 16px;
  margin-bottom: 0 !important;
  & > div {
    font-size: 0;
  }
`;

export const Box = styled.form`
  margin-bottom: 24px;
`;

export const BenefitRow = styled.li`
  ${rowStyles};
  padding: 8px 4px;
  &:not(&:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.colors['neutral-40']};
  }
`;

export const BenefitRowContent = styled.div`
  width: 100%;
`;

export const EditingBenefitRow = styled.div`
  display: flex;
  padding: 0;
  .input-wrapper {
    width: 100%;
    margin-right: 17px;
  }
`;

export const BenefitList = styled.ul`
  border: 1px solid ${(props) => props.theme.colors['neutral-40']};
  border-top: 0;
  border-radius: 0 0 4px 4px;
  padding: 0 8px;
`;

export const BoxHeader = styled.div`
  ${rowStyles};
  margin-bottom: 25px;
`;

export const ListHeader = styled.div`
  ${rowStyles};
  background-color: ${(props) => props.theme.colors['neutral-20']};
  border: 1px solid ${(props) => props.theme.colors['neutral-40']};
  border-radius: 4px 4px 0 0;
  padding: 8px 12px;
  p {
    font-size: 14px;
    line-height: 21px;
    font-weight: 600;
    color: ${(props) => props.theme.colors['neutral-80']};
  }
`;

export const BenefitText = styled.label`
  font-size: 14px;
  line-height: 21px;
  width: 100%;
  color: ${(props) => props.theme.colors['neutral-100']};
`;
